import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class StoreService {
  fetchStores() {
    return axios.get(API_URL + "store/get-company-stores", {
      headers: authHeader(),
    });
  }
  fetchParticularStore(storeId) {
    return axios.get(`${API_URL}store/get-particular-store/${storeId}`, {
      headers: authHeader(),
    });
  }
}

export default new StoreService();
